import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'

const request: AxiosInstance = axios.create({
  baseURL: '/api',
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
  },
})

// 请求拦截：自动注入 Authorization header
request.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('admin_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => Promise.reject(error)
)

// 响应拦截：401 自动跳转登录
request.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error) => {
    // 登录页自身的 401（密码错误）不触发整页重载，错误提示交给 LoginPage 就地渲染；
    // 业务页 401（token 失效/强制下线）才清登录态并跳转
    if (error.response?.status === 401 && window.location.pathname !== '/login') {
      localStorage.removeItem('admin_token')
      localStorage.removeItem('admin_user')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

// 便捷方法（返回 response.data.data 层）
export const get = <T>(url: string, config?: AxiosRequestConfig): Promise<T> =>
  request.get<{ code: number; data: T }>(url, config).then((res) => res.data.data)

export const post = <T>(url: string, data?: unknown, config?: AxiosRequestConfig): Promise<T> =>
  request.post<{ code: number; data: T }>(url, data, config).then((res) => res.data.data)

export const patch = <T>(url: string, data?: unknown, config?: AxiosRequestConfig): Promise<T> =>
  request.patch<{ code: number; data: T }>(url, data, config).then((res) => res.data.data)

export const del = <T>(url: string, config?: AxiosRequestConfig): Promise<T> =>
  request.delete<{ code: number; data: T }>(url, config).then((res) => res.data.data)

export default request
